import { render, staticRenderFns } from "./OferteProductieConfiguratorEU.vue?vue&type=template&id=81c9c486&scoped=true"
import script from "./OferteProductieConfiguratorEU.vue?vue&type=script&lang=js"
export * from "./OferteProductieConfiguratorEU.vue?vue&type=script&lang=js"
import style0 from "./OferteProductieConfiguratorEU.vue?vue&type=style&index=0&id=81c9c486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c9c486",
  null
  
)

export default component.exports